import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class SubscriptionsSerializer extends BaseSerializer {
  deserialize(raw) {
    const success = raw?.statusCode == 200 || raw?.id;

    const mockSubscriptions = [
      {
        id: 'sub_001',
        productName: 'Netflix Premium',
        productImage: '/kingrechargeAssets/netflix.svg',
        startDate: '2025-01-01T00:00:00Z',
        expiryDate: '2025-02-01T00:00:00Z',
        status: 'active',
        duration: '1 mois',
        autoRenew: false
      },
      {
        id: 'sub_002',
        productName: 'Spotify Premium',
        productImage: '/kingrechargeAssets/spotify.svg',
        startDate: '2024-12-15T00:00:00Z',
        expiryDate: '2025-03-15T00:00:00Z',
        status: 'active',
        duration: '3 mois',
        autoRenew: false
      },
      {
        id: 'sub_003',
        productName: 'Disney+',
        productImage: null,
        startDate: '2024-11-01T00:00:00Z',
        expiryDate: '2025-01-14T00:00:00Z',
        status: 'expired',
        duration: '1 mois',
        autoRenew: false
      },
      {
        id: 'sub_004',
        productName: 'Amazon Prime Video',
        productImage: null,
        startDate: '2024-12-01T00:00:00Z',
        expiryDate: '2025-01-20T00:00:00Z',
        status: 'active',
        duration: '1 mois',
        autoRenew: false
      }
    ];

    return {
      success,
      data: mockSubscriptions,
      total: mockSubscriptions.length
    };
  }

  serialize(data) {
    return null;
  }
}

export const subscriptionsSerializer = new SubscriptionsSerializer();
